import script from "./FileManager.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManager.vue?vue&type=script&setup=true&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=1c7bed95&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7bed95"]])

export default __exports__